<template>

    <div class="section container mx-auto mt-32 pb-20 w-10/12
                md:w-7/12">
        <h1 class="text-5xl mb-14 mx-auto font-bold text-center text-gray-800">ESCRIBINOS</h1>

        <div v-show="response" class="my-5 bg-green-100 rounded-md p-3 flex ">
            <svg class="stroke-2 stroke-current text-green-600 h-8 w-8 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round" ><path d="M0 0h24v24H0z" stroke="none" /> <circle cx="12" cy="12" r="9" /> <path d="M9 12l2 2 4-4" /> </svg>
            <div class="text-green-700">
                <div class="font-bold text-xl">Mensaje enviado con éxito</div>

                <div>Pronto nos estaremos comunicando contigo.</div>
            </div>
            <svg @click="closeResponse" class="stroke-4 stroke-current text-green-600 h-4 w-4 mr-2 ml-auto cursor-pointer hover:text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12" /></svg>
        
        </div>        
        
        <div class="grid grid-cols-2 gap-4">
            <div class="col-span-2
                        md:col-span-1
                        ">
                <label for="name" class="text-gray-900 block">Nombre</label> 
                <input v-model="form.name"  id="name" type="text" 
                       class="w-full mt-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring" 
                       placeholder="Ingrese su Nombre">
            </div> 
            <div class="col-span-2
                        md:col-span-1
                        ">
                <label for="lastname" class="text-gray-900 block">Apellido</label> 
                <input v-model="form.lastname"  id="lastname" type="text" 
                       class="w-full mt-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring" 
                       placeholder="Ingrese su Apellido">
            </div> 
            <div class="col-span-2
                        md:col-span-1
                        ">
                <label for="email" class="text-gray-900 block">Email</label> 
                <input v-model="form.email"  id="email" type="email" 
                       class="w-full mt-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring" 
                       placeholder="Ingrese su Email">
            </div> 
            <div class="col-span-2
                        md:col-span-1
                        ">
                <label for="phone" class="text-gray-900 block">Teléfono</label> 
                <input v-model="form.phone" id="phone" type="number" 
                       class="w-full mt-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring" 
                       placeholder="Ingrese su Teléfono">
            </div> 
            <div class="col-span-2
                        ">
                <label for="message" class="text-gray-900 block">Mensaje</label> 
                <textarea v-model="form.message"  id="message" type="text" 
                          class="w-full mt-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none focus:ring" 
                          placeholder="Ingrese el mensaje" />
            </div> 
        </div>

        <button @click="submit" class="flex mt-4 w-1/2 md:w-1/5 justify-center items-center tracking-widest px-6 py-4 text-sm font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg mx-auto">
            <span>ENVIAR</span>
            <Icons v-if="!this.loading" name="send" class="ml-2 w-4" />
            <Icons v-else name="loading" class="ml-2 w-4 text-white" />
       
        </button>  
    </div>

</template>

<script>
import Icons from '@/components/Icons.vue'  

export default {

    components:{
        Icons
    },
    data(){
        return{
            form:{},
            response: "",
            loading:false
        }
    },
    watch:{
        response: function(){
            this.form = {}
        }
    },
    methods:{
        
        closeResponse(){
            this.response = ""
        },

        submit(){
            this.sendForm()
            //this.$inertia.post(route('books.store'), this.form)
        },

        async sendForm(){

            this.loading = true
            const formData = new FormData();

            Object.entries(this.form).forEach(([key, value]) => {
                formData.append(key, value);
            });

            var post = `${process.env.VUE_APP_URL_CULTURAPP}api/messages`
            const r = await fetch(post,{method: 'POST', body:formData})
            this.response = await r.json()
            this.loading = false
        }
    }
}   
</script>
